<template>
  <div class="order-delete">
    <div class="orders-numbers-input">
      <vue-tags-input
        :key="reloadTags"
        v-model="orderNumber"
        :add-on-key="[13, ',', ';', ' ']"
        :separators="[',', ';', ' ']"
        :avoid-adding-duplicates="false"
        :placeholder="$t('admin.delete_placeholder')"
        v-on:tags-changed="updateOrderNumbers" />
      <button class="button button-primary" v-on:click="deleteOrders">
        {{ $t('admin.delete') }}
      </button>
    </div>
    <grid-deletable-orders :key="reloadGrid" />
  </div>
</template>
<script lang="ts">
import GridDeletableOrders from '@/components/orders/grid-order-deletable.vue';
import { OrdersService } from '@/services/orders.service';
import VueTagsInput from '@sipec/vue3-tags-input';
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'order-delete',
  components: {
    VueTagsInput,
    'grid-deletable-orders': GridDeletableOrders,
  },
  data() {
    return {
      ordersService: new OrdersService(),
      orderNumberList: [] as { text: string }[],
      orderNumber: '',
      reloadGrid: 0,
      reloadTags: 0,
    };
  },
  methods: {
    updateOrderNumbers(newOrderNumberList: { text: string }[]) {
      this.orderNumberList = newOrderNumberList;
    },
    async deleteOrders() {
      const orderNumbers = this.orderNumberList.map((tag) => tag.text);

      if (orderNumbers.length) {
        const result = await this.ordersService.deleteOrders(orderNumbers);

        this.$snotify.success(
          this.$t('admin.orders_correctly_deleted').toString() +
            result.model.reduce((text: string, orderNumber: string) => (text += `${orderNumber}, `), ''),
        );
        this.orderNumberList = [];
        this.reloadGrid++;
        this.reloadTags++;
      }
    },
  },
});
</script>
<style lang="scss">
.order-delete {
  padding: 20px 10px 0;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;

  .vue-tags-input {
    background-color: var(--primary-bg-color);
    border: 1px solid var(--border-color);
    color: var(--primary-text-input-color);
    max-width: initial;

    .ti-tag {
      height: 45px;
      box-sizing: content-box;
    }
  }

  .orders-numbers-input {
    display: flex;
    align-items: center;
    gap: 20px;
    padding-bottom: 20px;

    .vue-tags-input {
      flex: 1;
      border: none;
      max-width: 100%;

      .ti-new-tag-input-wrapper input {
        height: 30px;
        background: transparent;
        color: #000;
      }

      .ti-tag {
        height: 30px;
      }

      .ti-content {
        margin-left: 10px;
      }

      .ti-actions {
        border-left: 1px solid;
        padding-left: 10px;
        padding-right: 5px;
        margin-left: 10px;

        .ti-icon-close:before {
          content: '\2715';
        }
      }
    }
  }
}
</style>
